"use strict";
/**
 * * description should look something like {
 *      template: ["userList", (data) => {...data}],
 *      GET: { filters: ['dateCreated'], ordering: ['dateCreated'] },
 *      '/:id': {
 *          template: ["userDetail", (data) => {...data}],
 *          GET: { }
 *      }
 *   }
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCustomInterface = (store, namespace, description) => {
    let customInterface = {};
    Object.keys(description.getters).forEach(getterName => {
        customInterface[getterName] = payload => {
            return store.getters[namespace + '/' + getterName](payload);
        };
    });
    Object.keys(description.mutations).forEach(mutationName => {
        customInterface[mutationName] = payload => {
            return store.commit(namespace + '/' + mutationName, payload);
        };
    });
    return customInterface;
};
const safeInvokeWith = (func, withItem) => func && func instanceof Function ? func(withItem) : {};
class Interface {
    constructor(store, baseRoute, description, template = null, authorize = false, logger, baseURL = null, staticQuery = () => ({}), entry = res => res.data || res) {
        this.logger = logger;
        this.store = store;
        this.baseRoute = baseRoute;
        this.description = description;
        if (!template && !description['template']) {
            throw Error('Atleast one template is needed to create interface');
        }
        this.baseURL = description['baseURL'] || baseURL;
        this.authorize = description['authorize'] || authorize;
        this.staticQuery = () => (Object.assign(Object.assign({}, staticQuery(this.store)), safeInvokeWith(description['staticQuery'], this.store)));
        this.entry = description['entry'] || entry;
        this.template = description['template'] || template;
        Object.keys(description)
            .filter(key => key.startsWith('/'))
            .forEach(key => {
            if (key.startsWith('/:')) {
                this[key.substring(2)] = function (param) {
                    return new Interface(this.store, `${this.baseRoute}/${param}`, this.description[key], this.template, this.authorize, this.logger, this.baseURL, this.staticQuery, this.entry);
                };
            }
            else {
                this.logger.log('CREATING INTERFACE with template', this.template, 'for baseRoute', this.baseRoute);
                this[key.substring(1)] = new Interface(this.store, `${this.baseRoute}${key}`, this.description[key], this.template, this.authorize, this.logger, this.baseURL, this.staticQuery, this.entry);
            }
        });
    }
    get(options = {}, page = 1, upTo = null, cb) {
        if (!this.description['GET']) {
            throw Error('GET is not described for this interface');
        }
        this.logger.log('template for ', this.baseRoute, this.template);
        let storeCall = (pageNr, nextPageQuery = {}, reactive = null) => {
            let temp = this.store.getters[this.baseRoute.split('/')[0] + '/get'](this.store, this.baseRoute, this.description.GET['template'] || this.template, this.description.GET['authorize'] || this.authorize, this.description.GET['baseURL'] || this.baseURL, this.description.GET['staticQuery']
                ? Object.assign(Object.assign(Object.assign({}, this.staticQuery(this.store)), this.description.GET['staticQuery'](this.store)), nextPageQuery) : Object.assign(Object.assign({}, this.staticQuery(this.store)), nextPageQuery), this.description.GET['entry'] || this.entry, this.description.GET)(reactive !== null ? Object.assign(Object.assign({}, options), { reactive }) : options, pageNr);
            return temp;
        };
        // let range = (start, end) =>
        //     [...Array(1 + end - start).keys()].map(v => start + v);
        // if (upTo && page !== upTo) {
        //     return range(page, upTo)
        //         .map(storeCall)
        //         .reduce(
        //             (acc, val) => ({
        //                 ...acc,
        //                 data: [...acc.data, ...val.data],
        //                 loading: val.loading,
        //                 error: val.error,
        //             }),
        //             { data: [] }
        //         );
        // } else {
        //     return storeCall(page);
        // }
        const getPagePool = () => this.store.getters['pagePool/getPages']({ start: page, end: upTo });
        const getPages = (from, to) => __awaiter(this, void 0, void 0, function* () {
            this.store.commit('pagePool/setLoading', true);
            for (let i = from; i <= to; i++) {
                this.logger.log('calling storeCall with params', i);
                const nextPageQuery = i === 1
                    ? {}
                    : (() => {
                        const lastPageQuery = storeCall(i - 1, {}, true);
                        /* if (lastPageQuery.ids.length === 0) {
                            return false;
                        } */
                        return this.template[2].nextPageQuery(lastPageQuery.pageInfo);
                    })();
                if (!nextPageQuery) {
                    this.store.commit('pagePool/setHasNextPage', false);
                    break;
                }
                const result = yield storeCall(i, nextPageQuery, false);
                if (result.error) {
                    this.logger.log('Received error', result.error);
                    this.logger.log('Pagination encountered an error ', result.error);
                    this.store.commit('pagePool/setError', result.error);
                    break;
                }
                else {
                    this.logger.log('Should be pushing this', result);
                    this.store.dispatch('pagePool/pushPage', {
                        queryName: this.baseRoute + JSON.stringify(options),
                        data: result.data,
                        index: i,
                        queryInfo: result.queryInfo,
                    });
                }
            }
            this.store.commit('pagePool/setLoading', false);
        });
        if (upTo && page !== upTo) {
            this.logger.log(this.store.state.pagePool.query, this.baseRoute);
            if (this.store.state.pagePool.query !==
                this.baseRoute + JSON.stringify(options)) {
                this.logger.log('Initializing pagepool to size', upTo);
                this.store.dispatch('pagePool/initPool', {
                    queryName: this.baseRoute + JSON.stringify(options),
                    initPageSize: upTo,
                });
                let pagesPromise = getPages(1, upTo);
                if (!options.reactive) {
                    return pagesPromise.then(() => getPagePool());
                }
            }
            else if (upTo > this.store.state.pagePool.pages.length &&
                this.store.state.pagePool.hasNextPage) {
                let startAtPage = this.store.state.pagePool.pages.length;
                this.logger.log(upTo, this.store.state.pagePool.pages, startAtPage);
                let pagesPromise = getPages(startAtPage, upTo);
                if (!options.reactive) {
                    return pagesPromise.then(() => getPagePool());
                }
            }
            let pagePool = getPagePool();
            return pagePool;
        }
        else {
            return storeCall(page);
        }
    }
    post({ body, query }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.description['POST']) {
                throw Error('POST is not described for this interface');
            }
            if (!body) {
                throw Error('A body is required this method, post({body: {}}) is the minimum');
            }
            return this.store.dispatch(this.baseRoute.split('/')[0] + '/genericMethod', {
                url: this.baseRoute,
                method: 'POST',
                body,
                template: this.description.POST['template'] || this.template,
                authorize: this.description.POST['authorize'] || this.authorize,
                query,
                store: this.store,
                baseRoute: this.baseRoute,
                baseURL: this.description.POST['baseURL'] || this.baseURL,
                staticQuery: this.description.POST['staticQuery']
                    ? Object.assign(Object.assign({}, this.staticQuery(this.store)), this.description.POST['staticQuery'](this.store)) : this.staticQuery(this.store),
                entry: this.description.POST['entry'] || this.entry,
            });
        });
    }
    put({ body, query }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.description['PUT']) {
                throw Error('PUT is not described for this interface');
            }
            if (!body) {
                throw Error('A body is required this method, put({body: {}}) is the minimum');
            }
            return this.store.dispatch(this.baseRoute.split('/')[0] + '/genericMethod', {
                url: this.baseRoute,
                method: 'PUT',
                body,
                template: this.description.PUT['template'] || this.template,
                authorize: this.description.PUT['authorize'] || this.authorize,
                query,
                store: this.store,
                baseRoute: this.baseRoute,
                baseURL: this.description.PUT['baseURL'] || this.baseURL,
                staticQuery: this.description.PUT['staticQuery']
                    ? Object.assign(Object.assign({}, this.staticQuery(this.store)), this.description.PUT['staticQuery'](this.store)) : this.staticQuery(this.store),
                entry: this.description.PUT['entry'] || this.entry,
            });
        });
    }
    delete({ body, query }) {
        if (!this.description['DELETE']) {
            throw Error('DELETE is not described for this interface');
        }
        return this.store.dispatch(this.baseRoute.split('/')[0] + '/genericMethod', {
            url: this.baseRoute,
            method: 'DELETE',
            body,
            template: this.description.DELETE['template'] || this.template,
            authorize: this.description.DELETE['authorize'] || this.authorize,
            query,
            store: this.store,
            baseRoute: this.baseRoute,
            baseURL: this.description.DELETE['baseURL'] || this.baseURL,
            staticQuery: this.description.DELETE['staticQuery']
                ? Object.assign(Object.assign({}, this.staticQuery(this.store)), this.description.DELETE['staticQuery'](this.store)) : this.staticQuery(this.store),
            entry: this.description.DELETE['entry'] || this.entry,
        });
    }
    clear() {
        if (this.baseRoute.split('/').length > 1) {
            throw Error("RestX doesn't support clearing anything other than a base route, $interfaces.[base].clear() and not $interfaces.[base].[some other branch].clear()");
        }
        return this.store.dispatch(this.baseRoute + '/clear');
    }
}
exports.default = Interface;
